// CORE
// Este é um arquivo core do boilerplate e modificações neste arquivo serão bloqueadas via pré-hook de commit.
// Fazemos este bloqueio para manter a consistência do boilerplate e diminuir as chances de conflitos nos updates.
// Caso possível, procure uma alternativa ao uso deste arquivo.
// Se a alteração for realmente necessária ou for um update do boilerplate,
// realize o commit usando o comando 'git commit --no-verify'.

import {
  brandColors,
  commonColors,
  neutralColor,
  progressColors,
} from './colors';

const commonColorsWithAlias = Object.fromEntries(
  Object.entries(commonColors).map(([name, values]) => {
    const aliasedValues = { ...values, main: values.regular };
    return [name, aliasedValues];
  }),
);

export const palette = {
  neutral: neutralColor,
  ...brandColors,
  ...commonColorsWithAlias,
  progress: progressColors,
  background: {
    default: neutralColor[100],
  },
  success: commonColorsWithAlias.green,
  warning: commonColorsWithAlias.yellow,
  info: commonColorsWithAlias.blue,
  error: commonColorsWithAlias.red,
};